import { Delete } from '@mui/icons-material';
import React, { useState } from 'react';

import CDeleteConfirmationButton from './CDeleteConfirmationButton';
import CLocalizedText from './CLocalizedText';
import CLocalizedTextStringStatic from './CLocalizedTextStringStatic';
import CustomTextField from './CustomTextField';
import PageModuleFormGroup from './PageModuleFormGroup';
import PageModuleFormRow from './PageModuleFormRow';
import PaddedButton from './general/PaddedButton';

interface CAccountDeleteFormProps {
  selfDelete?: boolean;
  emailAddress: string;
  onCancel: () => void;
  onDelete: (email: string) => void;
}

export default function CAccountDeleteForm({ selfDelete, emailAddress, onCancel, onDelete }: CAccountDeleteFormProps) {
  const [input, setInput] = useState('');
  const [showModal, setShowModal] = useState(false);
  const paddedBtnText = CLocalizedTextStringStatic('accountDelete.buttonText');
  const modalText = CLocalizedTextStringStatic('accountDelete.modalText') + ' ' + emailAddress;

  const handleConfirm = () => {
    onDelete(input);
    setShowModal(false);
  };

  const emailLabel = CLocalizedTextStringStatic('textField.label.email');
  const selfDeleteString = CLocalizedTextStringStatic('accountDelete.user.description');
  const adminDeleteString = CLocalizedTextStringStatic('accountDelete.admin.description');

  return (
    <PageModuleFormGroup>
      <PageModuleFormRow>
        <CustomTextField
          label={emailLabel}
          placeholder={emailAddress}
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
          }}
        />
      </PageModuleFormRow>

      <PageModuleFormRow
        description={
          <>
            <p>{selfDelete ? selfDeleteString : adminDeleteString}</p>
            <CLocalizedText dictKey={'accountDelete.button.description.text'} />
          </>
        }
      >
        <PaddedButton
          growOnMobile={false}
          disabled={input !== emailAddress}
          label={paddedBtnText}
          icon={<Delete />}
          color="warning"
          onClick={() => {
            setShowModal(true);
          }}
        />
      </PageModuleFormRow>

      {showModal && (
        <CDeleteConfirmationButton
          showModal={showModal}
          onConfirm={handleConfirm}
          onCancel={() => {
            setShowModal(false);
            onCancel();
          }}
          title={modalText}
        />
      )}
    </PageModuleFormGroup>
  );
}
